module.exports = __webpack_public_path__ + "static/media/saagStory1.a9a2f1c1.ogg";